import * as yup from 'yup'
import {
  MAX_CHAT_ATTACHMENTS,
  MAX_CHAT_FILE_SIZE,
  MAX_CHAT_IMAGES,
  MAX_CHAT_IMAGE_SIZE,
} from 'constants/files'
import { MAX_CHAT_MESSAGE_LENGTH } from 'constants/chat'
import { DraftAttachment } from 'types/Chat'
import { countChatImages } from 'utils/chatAttachmentLimits'
import { isChatImage } from 'utils/getChatImageMimeType'

interface ChatInputValues {
  message: string
  attachments: DraftAttachment[]
}

const ChatInputSchema = yup.object().shape({
  message: yup.string().trim().max(MAX_CHAT_MESSAGE_LENGTH, 'aiChat.errors.message.tooLong'),
  attachments: yup.array().of(
    yup.object({
      id: yup.string().required(),
      file: yup.mixed<File>().required().test(
        'fileSize',
        'aiChat.errors.attachmentSize',
        (file) => !file || isChatImage(file) || file.size <= MAX_CHAT_FILE_SIZE
      ).test(
        'imageSize',
        'aiChat.errors.imageSize',
        (file) => !file || !isChatImage(file) || file.size <= MAX_CHAT_IMAGE_SIZE
      ),
    })
  )
    .test(
      'fileCount',
      'aiChat.errors.attachmentCount',
      (attachments = []) => (
        attachments.length - countChatImages(attachments) <= MAX_CHAT_ATTACHMENTS
      )
    )
    .test(
      'imageCount',
      'aiChat.errors.imageCount',
      (attachments) => countChatImages(attachments) <= MAX_CHAT_IMAGES
    )
    .required(),
}).test('has-content', 'aiChat.errors.message.required', (values) => (
  Boolean(values?.message?.trim() || values?.attachments?.length)
))

export type { ChatInputValues }

export { ChatInputSchema }
